import React from "react";
import { Layer, Stage } from "react-konva";
import Main from "../components/Layout";
import Sidebar from "../components/Sidebar";

import config from "../utils/config";
import TileShapeGroup from "../components/Builder/TileShapeGroup";
import SinkGroups from "../components/Builder/SinkGroup";
import GridStage from "../components/Builder/GridLine";
import StageWrapper from "../components/StageWrapper";

import { useGetBuilderDataQuery } from "../lib/redux/api/builder-api";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCanvasValues } from "../utils/canvas";
import { getDimensions, getLineAlignment, getSelectedVariation, getTileShape } from "../lib/redux/slices/dimensions-slice";
import { getSinks } from "../lib/redux/slices/sink-slice";
import { getHoles } from "../lib/redux/slices/holes-slice";

const MainLayout = () => {
  //Canvas Default Scale
  const currentShape = useSelector(getTileShape);
  const { top, left, bottom, right } = useSelector(getDimensions);
  const lineAlignment = useSelector(getLineAlignment);
  const { canvasTop, canvasLeft, canvasBottom, canvasRight } = getCanvasValues(
    { top, left, bottom, right },
    currentShape,
    lineAlignment
  );
  const selectedVariation = useSelector(getSelectedVariation);

  const sinks = useSelector(getSinks);
  const holes = useSelector(getHoles);
  
  const maxHeightWidth = sinks.length + holes.length;
  const [canvasSize, setCanvasSize] = React.useState({
    width: canvasTop,
    height: currentShape === 'right' ? canvasRight : canvasLeft,
  });
  const [scale, setScale] = React.useState(1);
  

  const [canvasOffsetX, setCanvasOffsetX] = React.useState(50);
  const [canvasOffsetY, setCanvasOffsetY] = React.useState(50);
  const [canvasOffsetX1, setCanvasOffsetX1] = React.useState(0);
  const [canvasOffsetY1, setCanvasOffsetY1] = React.useState(0);

  const groupRef = React.useRef(null);
  const stageRef = React.useRef(null);
  const [params] = useSearchParams();

  const category = params.get("cat");
  const catId = params.get("id");

  const { isLoading } = useGetBuilderDataQuery({
    category,
    catId,
  });

  const handleResize = React.useCallback(() => {
    const ratio = window.innerWidth >= 768 ? 1.8: 2.8
    const scaleX = window.innerWidth / (canvasSize.width * config.defaultRatio / ratio + (canvasOffsetX ));
    const scaleY = window.innerHeight / (canvasSize.height * config.defaultRatio / ratio  + canvasOffsetY);
    let scale = scaleX < scaleY ? scaleX : scaleY;


    scale = scale > 1  ? 1 : scale ;
    setScale(scale);

    setCanvasSize({
      width: canvasTop,
      height: currentShape === 'right' ? canvasRight : canvasLeft ,
    });

  }, [canvasLeft, canvasOffsetX, canvasOffsetY, canvasRight, canvasSize.height, canvasSize.width, canvasTop, currentShape]);

  React.useEffect(() => {
    // Attach the resize event listener when the component mounts
    window.addEventListener("resize", handleResize);

    // Call handleResize initially to set the initial scale
    handleResize();

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  React.useEffect(() => {
    setCanvasSize({
      width: canvasTop,
      height: currentShape === 'right' ? canvasRight : canvasLeft ,
    });

    const ratio = window.innerWidth >= 768 ? 1.8 : 2.4

    const scaleX = window.innerWidth / (canvasTop * config.defaultRatio / ratio + (canvasOffsetX ));
    const scaleY = window.innerHeight / (canvasLeft * config.defaultRatio / ratio  + canvasOffsetY);
    let scale = scaleX < scaleY ? scaleX : scaleY;


    scale = scale > 1  ? 1 : scale ;
    setScale(scale);
    // handleResize()
    
  }, [canvasTop, canvasLeft, currentShape, canvasRight, selectedVariation, canvasOffsetX, canvasOffsetY,lineAlignment])

  return (
    <>
      <Main>
        <Sidebar stage={stageRef} canvasOffsetX={canvasOffsetX} isLoading={isLoading}/>
        {!isLoading && (
          <StageWrapper
            // width={canvasSize.width  + canvasOffsetX}
            // height={canvasSize.height + canvasOffsetY}
            className='stageWrapper'
          >
            <GridStage size={16} />
            <div
              className="konva-stage"
              style={{
                transform: `scale(${scale})`,
                transformOrigin: '10% 20%',
                padding: `${config.canvasSpace}px`,
              }}
            >
              <Stage
                width={canvasSize.width  + 60  + (canvasOffsetX * ((maxHeightWidth + 1)))}
                height={canvasSize.height + 60  + (canvasOffsetY  * ((maxHeightWidth + 1)))}
                x={canvasOffsetX}
                y={canvasOffsetY}
                ref={stageRef}
              >

                <Layer>
                  {/* L-shape Group */}
                  <TileShapeGroup
                    {...{
                      groupRef,
                      canvasOffsetX,
                      canvasOffsetY,
                      canvasOffsetX1,
                      canvasOffsetY1,
                      scale,
                    }}
                  />
                  <SinkGroups
                    {...{
                      canvasOffsetX,
                      canvasOffsetY,
                      setCanvasOffsetX,
                      setCanvasOffsetY,
                      setCanvasOffsetX1,
                      setCanvasOffsetY1,
                      stageRef,
                    }}
                  />
                </Layer>
              </Stage>
            </div>
          </StageWrapper>
        )}
      </Main>
    </>
  );
};

export default MainLayout;
